import { Button, Col, Row, Select, Switch, Tooltip } from "antd";
import { get, map } from "lodash";
import React, { useEffect, useEffectEvent, useMemo, useRef, useState } from "react";
import { bingoImageUrl, COLORS } from "utils/config/reference";
import { generateRandomLightColor } from "utils/methods/math";
import "./bingo.css";
import BingoWheelComponent from "./BingoWheel/BingoWheelComponent";
import PlayThemeSong from "./playThemeSong/playThemeSong";
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import { CaretRightOutlined, InfoCircleOutlined, PauseOutlined } from "@ant-design/icons";
const BingoStudentsResult = ({
  debateInfo,
  handleClickStudentDetail = () => null,
  studentSubmission,
  currentUser,
  setWheelSpinResult,
  wheelSpinResult = [],
  updateCollectionForWheel = () => {},
  showNames,
  debateResponse = {},
  setShowNames,
  themeSongProps = {},
  disableAutoSpin = false
}) => {
  const [segColors, setSegColors] = useState([]);
  const [result, setResult] = useState("");
  const [loader, setLoader] = useState({ type: "", value: false });
  const [WheelBingoData, setWheelBingoData] = useState([]);
  const [cooldown, setCooldown] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [autoPlayEnabled, setAutoPlayEnabled] = useState(false);
  const [autoSpinIntervalSeconds, setAutoSpinIntervalSeconds] = useState(undefined);
  const [isWheelSpinning, setIsWheelSpinning] = useState(false);
  const [intervalSpinNonce, setIntervalSpinNonce] = useState(0);
  const [autoSpinPaused, setAutoSpinPaused] = useState(false);
  const cooldownIntervalRef = useRef(null);
  const prevAutoSpinIntervalRef = useRef(autoSpinIntervalSeconds);
  const AUTO_SPIN_TIME_OPTIONS = [3, 5, 10, 15, 20, 30];
  const matchesWheelWinner = (userValue, winner) => {
    if (userValue === winner) return true;
    if (userValue == null || winner == null || winner === "") return false;
    return String(userValue) === String(winner);
  };
  const autoSpinIntervalOverride = autoPlayEnabled
    ? (typeof autoSpinIntervalSeconds === "number" ? autoSpinIntervalSeconds : 0)
    : 0;

  useEffect(() => {
      setAutoPlayEnabled(false);
      setAutoSpinIntervalSeconds(3);
      setAutoSpinPaused(false);
  }, [debateInfo?.id]);

  const submittedStudentSubmission = studentSubmission
    .filter(
      (item) =>
        item?.student_status === "submitted" &&
        item?.teacher_response !== "reject" &&
        item?.teacher_response !== "taking"
    )
    .sort((a, b) => new Date(a.answer_time) - new Date(b.answer_time));

  const isTeacher = useMemo(
    () => get(currentUser, "role") === "teacher",
    [currentUser]
  );
  const bingoData =
    (debateInfo &&
      debateInfo?.bingo_data &&
      JSON.parse(debateInfo?.bingo_data)) ||
    [];

useEffect(() => {
  try {
    setLoader({ type: "fetchContent", value: true });
    const loteriaData =
      (debateInfo &&
        debateInfo?.bingo_data &&
        JSON.parse(debateInfo?.bingo_data)) ||
      [];
    const { configurations } = debateInfo || {};
    const segColors = Array.isArray(loteriaData)
      ? map(
          loteriaData,
          (k, i) => `${COLORS[i] ? COLORS[i] : generateRandomLightColor()}`
        )
      : [];
    setSegColors(segColors);

    // Reset local result state only; preserve wheelSpinResult across view toggles
    setResult("");
    // setWheelSpinResult([]);
    if (wheelSpinResult?.length > 0) {
      const data = bingoData?.filter(
        (item) => !wheelSpinResult.some((x) => x.id === item.id)
      );
      const updatedData =
        configurations?.bingo_type !== "OnlyImage"
          ? data
          : data.map((item, index) => ({
              ...item,
              value: index,
            }));
      setWheelBingoData(updatedData);
    } else {
      const updatedWheelBingoData =
        configurations?.bingo_type !== "OnlyImage"
          ? bingoData?.flat()
          : bingoData?.flat().map((item, index) => ({
              ...item,
              value: index,
            }));
      setWheelBingoData(updatedWheelBingoData);
    }
  } catch (error) {
    Sentry.captureException(`622 Error in useEffect: ${error}`);
    console.log(error);
  } finally {
    setLoader({ type: "", value: false });
  }
}, [debateInfo?.id]);

  useEffect(() => {
    return () => {
      if (cooldownIntervalRef.current) {
        clearInterval(cooldownIntervalRef.current);
        cooldownIntervalRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const prev = prevAutoSpinIntervalRef.current;
    if (prev === autoSpinIntervalSeconds) {
      return;
    }
    prevAutoSpinIntervalRef.current = autoSpinIntervalSeconds;
    if (!autoPlayEnabled || !cooldown) {
      return;
    }
    if (cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current);
      cooldownIntervalRef.current = null;
    }
    const seconds =
      typeof autoSpinIntervalSeconds === "number" && autoSpinIntervalSeconds > 0
        ? autoSpinIntervalSeconds
        : 3;
    setRemainingTime(seconds);
    cooldownIntervalRef.current = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          if (cooldownIntervalRef.current) {
            clearInterval(cooldownIntervalRef.current);
            cooldownIntervalRef.current = null;
          }
          setCooldown(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  }, [autoSpinIntervalSeconds, autoPlayEnabled, cooldown]);

const onFinished =  useEffectEvent( async (winner) => {
  if (cooldown) {
    return;
  }

    try {
      if (cooldownIntervalRef.current) {
        clearInterval(cooldownIntervalRef.current);
        cooldownIntervalRef.current = null;
      }
      setCooldown(true);
      const effectiveInterval = autoPlayEnabled
        ? autoSpinIntervalSeconds : 3;
      const cooldownSeconds = typeof effectiveInterval === "number" && effectiveInterval > 0 ? effectiveInterval : 3;
      setRemainingTime(autoPlayEnabled ? cooldownSeconds : 3);

      cooldownIntervalRef.current = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime <= 1) {
            if (cooldownIntervalRef.current) {
              clearInterval(cooldownIntervalRef.current);
              cooldownIntervalRef.current = null;
            }
            setCooldown(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      setLoader({ type: "wheel_spin", value: true });
      const winnerDataIndex = WheelBingoData.findIndex((user) =>
        matchesWheelWinner(user.value, winner)
      );
      const cellData = WheelBingoData[winnerDataIndex];
      if (WheelBingoData?.length > 1) {
        const winnerIndex = WheelBingoData.findIndex((user) =>
          matchesWheelWinner(user.value, winner)
        );
        if (winnerIndex !== -1) {
          const updatedSelectedUsers = [
            ...WheelBingoData.slice(0, winnerIndex),
            ...WheelBingoData.slice(winnerIndex + 1),
          ];

          setWheelSpinResult((prev) => {
            const updatedResults = prev?.length > 0 ? [...prev, cellData] : [cellData];
  
            // Call updateCollectionForWheel inside the state update function
            updateCollectionForWheel(updatedResults);
            return updatedResults;
          });

          setWheelBingoData(updatedSelectedUsers);
          setSegColors((prevState) =>
            prevState?.filter((_, index) => index !== winnerIndex)
          );
        }
      } else if (WheelBingoData?.length === 1) {
        // Last item selected - game ends, reset wheel data
        const winnerIndex = WheelBingoData.findIndex((user) =>
          matchesWheelWinner(user.value, winner)
        );
        if (winnerIndex !== -1) {
          setWheelSpinResult((prev) => {
            const updatedResults = prev?.length > 0 ? [...prev, cellData] : [cellData];
  
            // Call updateCollectionForWheel inside the state update function
            updateCollectionForWheel(updatedResults);
            return updatedResults;
          });

          setWheelBingoData([]);
          setSegColors([]);
        }
      }
      setResult(winner);
    } catch (error) {
      Sentry.captureException(`623 Error in onFinished: ${error}`);
      console.log(error);
    } finally {
      setLoader({ type: "", value: false });
    }
  });

  const playAutoSpin = () => {
    if (!autoPlayEnabled) {
      return;
    }

    if (!autoSpinPaused) {
      return;
    }

    setAutoSpinPaused(false);
    setIntervalSpinNonce((n) => n + 1);
  }

  return (
    <SentryWrap>
      <div className="ideaMdlUpr">
      <Row>
        <Col xs={24}>
          <div className="uprDebateStudntListing bingoStudentListing">
            <div className="debateMdlTop debateAllTopTxt debateAllTopSpace bingoTopTxt">
              <img
                className="bingo-logo newBingoLogo"
                src={bingoImageUrl}
                alt="Debate"
              />
              <div className="topSliderHeaderTxt bingoTopSliderHeader">
                <span>{debateInfo?.question}</span>
              </div>
            </div>
            <PlayThemeSong {...themeSongProps} resetKey={debateInfo?.id} />
          </div>
        </Col>
        <div style={{marginTop: window.innerWidth < 1200 ? "20px" : "0px"}} className="flex items-center justify-end w-full mb-10px">
              <span>Spinning timer</span>
              <Switch
                checked={autoPlayEnabled}
                onChange={(checked) => {
                  setAutoPlayEnabled(checked);
                  setAutoSpinPaused(false);
                  if (checked) {
                    if (cooldownIntervalRef.current) {
                      clearInterval(cooldownIntervalRef.current);
                      cooldownIntervalRef.current = null;
                    }
                    setCooldown(false);
                    setRemainingTime(0);
                    setAutoSpinIntervalSeconds(undefined);
                    return;
                  }

                  if (cooldownIntervalRef.current) {
                    clearInterval(cooldownIntervalRef.current);
                    cooldownIntervalRef.current = null;
                  }
                  setCooldown(false);
                  setRemainingTime(3);
                  setAutoSpinIntervalSeconds(3);
                  setIntervalSpinNonce((n) => n + 1);
                }}
                style={{ marginLeft: 8 }}
                disabled={isWheelSpinning}
              />
              {autoPlayEnabled && (
                <span style={{ marginLeft: 12, display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                  <span style={{ marginRight: 6 }}>Interval (sec)</span>
                  <Select
                    value={autoSpinIntervalSeconds}
                    placeholder="Please select"
                    onChange={(value) => {
                      setAutoSpinIntervalSeconds(value);
                      if (!autoPlayEnabled) {
                        return;
                      }
                      if (cooldownIntervalRef.current) {
                        clearInterval(cooldownIntervalRef.current);
                        cooldownIntervalRef.current = null;
                      }
                      setCooldown(false);
                      setRemainingTime(value);
                      setIntervalSpinNonce((n) => n + 1);
                    }}
                    options={AUTO_SPIN_TIME_OPTIONS.map((sec) => ({
                      label: `${sec} seconds`,
                      value: sec
                    }))}
                    style={{ width: 142 }}
                    disabled={isWheelSpinning}
                  />
                  {autoSpinIntervalSeconds !== undefined && (
                  <Button
                    type="default"
                    icon={autoSpinPaused ? <CaretRightOutlined /> : <PauseOutlined />}
                    onClick={() => {
                      setRemainingTime(0);
                      setAutoSpinPaused((p) => {
                        const next = !p;
                        if (!next) {
                          setIntervalSpinNonce((n) => n + 1);
                        }
                        return next;
                      });
                    }}
                    disabled={isWheelSpinning}
                  />
                  )}
                </span>
              )}
              <Tooltip
                    title="When the spinning timer is enabled, the wheel will automatically spin after you select a value, and each subsequent spin will begin after the specified interval."
                    trigger="click"
                    placement="top"
                  >
                    <InfoCircleOutlined
                      style={{ marginLeft: 6, cursor: "pointer", color: "#1677ff" }}
                    />
                </Tooltip>
              
            </div>
        <Col xs={24}>
          <div className="topSliderHeaderTxtBingo">
            <span>{debateInfo?.question}</span>
          </div>
        </Col>
        <Col xs={24} sm={24} lg={13}>
          <BingoWheelComponent
            states={{
              result,
              isTeacher,
              segColors,
              loader,
              bingoData: WheelBingoData,
              cooldown,
              remainingTime,
              debateResponse,
              debateInfo: debateInfo?.configurations,
              disableAutoSpin: disableAutoSpin || autoSpinPaused,
                  autoSpinIntervalOverride,
              intervalSpinNonce,

            }}
            funcObj={{ onFinished, setWheelSpinResult, setIsWheelSpinning, playAutoSpin }}
          />
        </Col>
        <Col xs={24} sm={24} lg={11}>
          <div className="bingoStdntSection">
            <div className="debateTpcBtns bingoTpcBtn submissionBtnStudent">
              {Array.isArray(submittedStudentSubmission) && submittedStudentSubmission.length > 0 ? (
                map(submittedStudentSubmission, (item, index) => (
                  <Button
                    className="studentNameBtn"
                    key={index}
                    onClick={() => {
                      handleClickStudentDetail(item?.submission_id);
                    }}
                  >
                    {showNames ? (
                      item?.user_name && item?.user_name?.length > 18 ? (
                        <Tooltip title={item.user_name}>
                          <span className="ellipsisText">{item?.user_name?.slice(0, 18) + "..."}</span>
                        </Tooltip>
                      ) : (
                        <Tooltip title={item.user_name}>
                        <span className="ellipsisText">{item?.user_name}</span>
                      </Tooltip>
                      )
                    ) : (
                      `Estudiante ${index + 1}`
                    )}
                  </Button>
                ))
              ) : (
                <div className="studentResponceSec bingoResponceSection">
                  <span>Waiting for students response...</span>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col xs={24}>
          <div className="debeteCountTypeSec debeatLstStdentSec">
            <div className="debatCountTxt">
              <span>Show student names</span>
              <Switch
                checked={showNames}
                onChange={(checked) => setShowNames(checked)}
              />
            </div>
            <div className="debeatStdntRspns bingoStdntResponce">
              <span>Click on the response to show the answer.</span>
            </div>
          </div>
        </Col>
      </Row>
      </div>
    </SentryWrap>
  );
};

export default BingoStudentsResult;
